module.exports = __webpack_public_path__ + "img/team-icon.544378e6.png";